import { Card, CardActionArea, CardContent, Container } from '@mui/material';
import Grid from '@mui/material/Grid';
import React from 'react';
import { useTranslation } from 'react-i18next';
import useStyles from './style';
import { Link } from 'react-router-dom';
import { DashboardMetricType } from 'modules/transport-operator/adapters/dashboard/queries';
import {
  dashboardMetricTypeSearchParam,
  fromDashboardSearchParam,
} from 'modules/global/helpers/searchParamsHelper';

type DashboardTile = {
  title: string;
  textBody?: string;
  number?: number;
  linkTo?: string;
  dashboardMetricType?: DashboardMetricType;
};

export type DashboardGroup = {
  tiles: DashboardTile[];
  fetchingText?: string;
};

type Props = React.ComponentPropsWithoutRef<'div'> & {
  dashboardGroup: DashboardGroup;
  isFetching: boolean;
};

const DashboardScreen = ({ dashboardGroup, isFetching }: Props) => {
  const { t } = useTranslation('useCase');
  const { classes } = useStyles();

  return (
    <Container disableGutters maxWidth={false} className={classes.container} sx={{ px: 3 }}>
      <h1 className={classes.pageTitle}>{t('general.dashboard')}</h1>
      <React.Fragment>
        <Grid container spacing={3}>
          {dashboardGroup?.tiles?.map((actionCard) => (
            <Grid size={3} key={actionCard.title}>
              {actionCard.linkTo ? (
                <Link
                  to={
                    actionCard.linkTo +
                    `?${fromDashboardSearchParam}=true` +
                    (actionCard.dashboardMetricType
                      ? `&${dashboardMetricTypeSearchParam}=${actionCard.dashboardMetricType}`
                      : '')
                  }
                >
                  <Card variant="outlined" className={classes.actionCardWrapper}>
                    <CardActionArea>
                      <CardContent className={classes.actionCard}>
                        <h3>{actionCard.title}</h3>
                        <p>{isFetching ? dashboardGroup.fetchingText : actionCard.textBody}</p>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Link>
              ) : (
                <Card variant="outlined" className={classes.actionCardWrapper}>
                  <CardActionArea>
                    <CardContent className={classes.actionCard}>
                      <h3>{actionCard.title}</h3>
                      <p>{isFetching ? dashboardGroup.fetchingText : actionCard.textBody}</p>
                    </CardContent>
                  </CardActionArea>
                </Card>
              )}
            </Grid>
          ))}
        </Grid>
      </React.Fragment>
    </Container>
  );
};

export default DashboardScreen;
